export default "__VITE_ASSET__BndmEo5d__"